import { Box, Dialog, Typography } from '@mui/material'
import type React from 'react'
import {
  ErrorRounded,
  InfoRounded,
  CheckCircleRounded,
  WarningRounded
} from '@mui/icons-material'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { color } from 'config/color'

interface AlertDialogProps {
  type: 'info' | 'warning' | 'error' | 'success'
  message: string
  open: boolean
  handleClick: () => void
  children?: any
  title: string
}

const defaultIconStyle = {
  fontSize: 60,
  borderRadius: '50%',
  padding: 3
}

export const AlertDialog: React.FC<AlertDialogProps> = ({
  open,
  handleClick,
  type,
  message,
  children,
  title
}) => {
  const isMobile = useMobileBreakpoints()
  return (
    <Dialog open={open} onClick={handleClick} onClose={handleClick}>
      <Box textAlign="center" p={isMobile ? 3 : 5} maxWidth={420}>
        {type === 'info' && (
          <InfoRounded
            sx={{
              color: color.primary[600],
              backgroundColor: color.primary[50],
              ...defaultIconStyle
            }}
          />
        )}
        {type === 'warning' && (
          <WarningRounded
            sx={{
              color: color.warning[600],
              backgroundColor: color.warning[50],
              ...defaultIconStyle
            }}
          />
        )}
        {type === 'error' && (
          <ErrorRounded
            sx={{
              color: color.error[600],
              backgroundColor: color.error[50],
              ...defaultIconStyle
            }}
          />
        )}
        {type === 'success' && (
          <CheckCircleRounded
            sx={{
              color: color.success[600],
              backgroundColor: color.success[50],
              ...defaultIconStyle
            }}
          />
        )}
        <Box my={2}>
          <Typography
            textTransform="capitalize"
            textAlign="center"
            fontSize={24}
            fontWeight={500}
            color={color.grey[900]}
            mb={1}
          >
            {title}
          </Typography>
          <Typography
            textAlign="center"
            fontSize={16}
            fontWeight={400}
            color={color.grey[700]}
          >
            {message.includes('<')
            ? (
              <Box
                sx={{
                  a: {
                    color: color.primary[600]
                  }
                }}
              >
                <span dangerouslySetInnerHTML={{ __html: message }} />
              </Box>
            )
            : (
              message
            )}
          </Typography>
        </Box>
        {children}
      </Box>
    </Dialog>
  )
}
